import styled from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';

export const Wrapper = styled.div`
  font-family: ${FONTS.ARISTOTELICA};
  line-height: 20px;
  background: ${COLORS.YELLOW};
  padding: 20px 16px;

`;

export const Container = styled.div`

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: 1200px;
    margin: 0 auto;
  }
`;

export const Text = styled.h1`
  margin-bottom: 10px;
  font-size: 18px;
  line-height: 20px;
  font-weight: 400;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 30px;
    line-height: 33px;
  }
`;
